// Payment issue statuses that require user action
const PAYMENT_ISSUE_STATUSES = ["incomplete", "past_due", "unpaid"] as const;

export type PaymentIssueStatus = "incomplete" | "past_due" | "unpaid";

export const hasPaymentIssue = (status: string | null | undefined): boolean => {
  if (!status) {
    return false;
  }
  return PAYMENT_ISSUE_STATUSES.includes(status as PaymentIssueStatus);
};

export const getPaymentIssueMessage = (status: string): string => {
  const messages: Record<PaymentIssueStatus, string> = {
    past_due: "You have an unpaid invoice. Please pay it to resume your subscription.",
    incomplete:
      "Your subscription payment failed. Please pay the outstanding invoice to resume your subscription.",
    unpaid:
      "Your subscription payment failed after multiple attempts. Please pay the outstanding invoice to resume your subscription.",
  };

  return messages[status as PaymentIssueStatus] || "There is an issue with your subscription.";
};

export const getPaymentIssueAction = (
  status: string,
): "pay_invoice" | "update_payment_method" | "create_subscription" => {
  switch (status) {
    case "past_due":
    case "unpaid":
      return "pay_invoice";
    case "incomplete":
      return "update_payment_method";
    default:
      return "pay_invoice";
  }
};

export const getPaymentIssueButtonLabel = (status: string): string => {
  switch (status) {
    case "past_due":
    case "unpaid":
      return "Pay Invoice";
    case "incomplete":
      return "Update Payment Method";
    default:
      return "Resolve Issue";
  }
};
